<template>
  <div>
    <v-form ref="form" v-model="valid" :lazy-validation="true" class="pwc-form-data">
      <template v-for="(item, index) in questionList">
        <h3 v-if="item.type === 'text'" :key="item.key" style="line-height: 30px; font-size: 16px">{{ formatText(item) }}</h3>
        <div v-if="item.type === 'input' || item.type === 'number'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <div v-if="item.meta.dataType === 'phone'" style="display: flex">
            <v-select v-model="item.meta.countryCode" :items="item.options.map(v =>{return {label: `${v.name}(+${v.code})`, ...v}})" :disabled="item.meta.disabled" solo style="width: 0; margin-right: 10px; position: relative; top:10px;" item-text="label" item-value="code" label="Country Code" @change="(val) => {$refs.form.resetValidation(); checkPhone(item, true)}" />
            <v-text-field :id="item.key" v-model="formData[item.key]" type="number" :rules="item | getProperyRule" :disabled="item.meta.disabled" :required="item.required" style="margin-top: 10px" :placeholder="item.meta.placeholder" solo @input="(val) => {validField(item, val); checkNextShow(item, index, val); checkPhone(item, true)}" @blur="checkIsSubmit(item)"/>
          </div>
          <v-text-field
            v-else-if="item.default === 'SCHOOL'"
            :id="item.key"
            v-model="formData[item.key]"
            autocomplete="off"
            style="margin-top: 10px"
            :disabled="item.meta.disabled"
            :placeholder="item.meta.placeholder"
            type="text"
            :rules="item | getProperyRule"
            :required="item.required"
            solo
            @mousewheel.native.prevent
            @input="(val) => {checkNextShow(item, index); handleDebounceSchoolSearch(val)}"
            @focus="handleSchoolFocus"
            @blur="handleSchoolBlur"
          />
          <v-text-field
            v-else
            :id="item.key"
            v-model="formData[item.key]"
            :type="item.type === 'number'? 'number': 'text'"
            :disabled="item.meta.disabled"
            :rules="item | getProperyRule"
            :required="item.required"
            style="margin-top: 10px"
            :placeholder="item.meta.placeholder"
            solo
            @input="(val) => {validField(item, val); checkNextShow(item, index, val)}"
            @blur="() => {formatNumber(item, index)}"
          />
          <!-- checkNextShow(item, index); -->
          <div v-if="showSchoolPane && item.default === 'SCHOOL'" class="pwc-school-pane desktop">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-for="school in filteredSchoolList" :key="school" class="pwc-school-item" @click="handleSchoolSelect(school)" v-html="highlightKeyWord(school)" />
            <div v-if="filteredSchoolList.length === 0" class="pwc-school-item no-match" style="color: #777;">no match</div>
          </div>
        </div>
        <div v-if="item.type === 'textarea'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-textarea :id="item.key" v-model="formData[item.key]" :rules="item | getProperyRule" :disabled="item.meta.disabled" :required="item.required" style="margin-top: 10px" :placeholder="item.meta.placeholder" outline @input="(val) => {validField(item, val); checkNextShow(item, index, val)}" />
          <!-- @change="() => {checkNextShow(item, index)}" -->
        </div>
        <div v-if="item.type === 'radio'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-radio-group v-model="formData[item.key]" :rules="item | getProperyRule" :disabled="item.meta.disabled" :required="item.required" @change="(val) => {validField(item, val); checkNextShow(item, index, val)}">
            <v-radio v-for="(n, ind) in item.options" :key="ind" color="#d04a02" :label="n.value" :value="n.defaultId || n.id" />
            <v-text-field v-show="formData[item.key]&&formData[item.key].endsWith('Other')" :id="item.key" v-model="formData[item.key + 'Other']" :required="item.required" style="margin-top: 10px" :placeholder="'请输入'" solo @blur="(val) => {validField(item, val);}" />
            <div class="error-msg" :class="validate[item.key + 'Other'] ? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</div>
          </v-radio-group>
        </div>
        <div v-if="item.type === 'checkbox'" :key="item.key" class="field-item">
          <!-- eslint-disable-next-line -->
          <p v-if="item.QuestionId&&item.QuestionId.endsWith('CLAUSE')" class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key" v-html="item.formatLabel" />
          <p v-else class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <component :is="item | getComponentName" :id="item.key" :key="item.key" v-model="formData[item.key]" :disabled="item.meta.disabled" :rules="item | getProperyRule" solo>
            <v-checkbox v-for="o in item.options" :key="o.id" v-model="formData[item.key]" color="#d04a02" multiple :label="o.value" :value="o.id" @change="() => {validField(item, null); checkNextShow(item, index)}" />
            <!-- @change="() => {checkNextShow(item, index)}" -->
            <v-text-field v-show="formData[item.key]&&formData[item.key].find((item) => {return item.endsWith('Other')})" :id="item.key" v-model="formData[item.key + 'Other']" :required="item.required" style="margin-top: 10px" :placeholder="'请输入'" solo @blur="(val) => {validField(item, val);}" />
            <div v-if="formData[item.key]&&formData[item.key].find((item) => {return item.endsWith('Other')})" class="error-msg" :class="validate[item.key + 'Other'] ? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</div>
            <div class="error-msg" :class="validate[item.key] ? 'active': ''">{{ validateMsg[item.key] }}</div>
          </component>
        </div>
        <div v-if="item.type === 'checkboxInput'" :key="item.key" class="field-item">
          <!-- eslint-disable-next-line -->
          <p v-if="item.QuestionId&&item.QuestionId.endsWith('CLAUSE')" class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key" v-html="item.formatLabel" />
          <p v-else class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <component :is="item | getComponentName" :id="item.key" :key="item.key" v-model="formData[item.key]" :disabled="item.meta.disabled" :rules="item | getProperyRule" solo>
            <div v-for="o in item.options" :key="o.id">
              <v-checkbox v-model="formData[item.key]" color="#d04a02" multiple :label="o.value" :value="o.id" @change="() => {validField(item, null); checkNextShow(item, index)}" />
              <v-text-field v-show="formData[item.key]&&formData[item.key].includes(o.id)" v-model="formData[item.key + 'Input'][o.id]" :required="item.required" style="margin-top: 10px;" solo @blur="(val) => {validField(item, val); checkNextShow(item, index)}" />
            </div>
            <!-- @change="() => {checkNextShow(item, index)}" -->
            <div class="error-msg" :class="validate[item.key] ? 'active': ''">{{ validateMsg[item.key] }}</div>
          </component>
        </div>
        <!-- eslint-disable-next-line -->
        <div v-if="item.type === 'sorting'" :key="item.key" class="field-item sorting">
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <draggable tag="div" :list="item.options" v-bind="{group:{ name:'options'}, ghostClass: 'ghost', handle: '.drag-item'}" handle=".drag-item" @end="() => {sortingChange(item)}">
            <div v-for="(o, ind) in item.options" :key="ind" class="drag-item van-radio__label">
              <v-text-field v-show="o.id.endsWith('Other')" v-model="formData[item.key + 'Other']" :required="item.required" style="margin-top: 10px; margin-right: 10px;" solo @blur="(val) => {validField(item, val);}" />
              <span v-show="!o.id.endsWith('Other')">{{ o.value }}</span>
              <van-icon name="wap-nav" />
            </div>
          </draggable>
        </div>

        <div v-if="item.type === 'select'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-select
            :id="item.key"
            v-model="formData[item.key]"
            :rules="item | getProperyRule"
            :required="item.required"
            :disabled="item.meta.disabled"
            :label="item.label"
            :placeholder="item.meta.placeholder || '请选择 please select'"
            solo
            style="margin-top: 10px"
            :items="item.options"
            item-text="value"
            item-value="id"
            @change="(val) => {validField(item, val); checkNextShow(item, index, val)}"
          />
          <v-text-field v-if="formData[item.key]&&formData[item.key].endsWith('Other')" :id="item.key" v-model="formData[item.key + 'Other']" :required="item.required" style="margin-top: 10px" :placeholder="'请输入'" solo @blur="(val) => {validField(item, val);}" />
          <div class="error-msg" :class="validate[item.key + 'Other'] ? 'active': ''">{{ validateMsg[item.key + 'Other'] }}</div>
        </div>
        <div v-if="item.type === 'date'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-menu
            :id="item.key"
            :key="item.key"
            v-model="item['dateShow']"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formData[item.key]" :rules="item | getProperyRule" :required="item.required" :disabled="item.meta.disabled" persistent-hint readonly solo append-icon="fas fa-calendar-check" v-on="on" @change="(val) => {checkNextShow(item, index)}" />
            </template>
            <!-- @change="(val) => {checkNextShow(item, index)}" -->
            <v-date-picker v-model="formData[item.key]" :type="item.meta.type.includes('date') ? 'date': 'month'" no-title @input="item['dateShow'] = false" />
          </v-menu>
        </div>
        <div v-if="item.type === 'fileupload' || item.type === 'imgupload'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <!-- checkNextShow(item, index) -->
          <pwc-uploader :id="item.key" style="margin:20px 0" :delay="delay" 
          @uploadFileList="uploadFileList" @hasUpload="hasUpload" 
          :hasfile-list="formData[item.key]" :disabled="item.meta.disabled" :options="item"
           @selectedFile="() => {validField(item, null);checkNextShow(item, index)}"
           @uploaded="(val) => {uploaded(val, item)}"
           @uploadOrDelete="(val) => {uploadOrDelete(val, item)}" />
          <p class="error-msg" :class="validate[item.key] ? 'active': ''">{{ validateMsg[item.key] }}</p>
        </div>
        <div v-if="item.type === 'uploadImgs'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <!-- checkNextShow(item, index) -->
          <upload-imgs :id="item.key" style="margin:20px 0" :hasfile-list="formData[item.key]" :delay="delay" :disabled="item.meta.disabled" :options="item" @selectedFile="() => {validField(item, null);checkNextShow(item, index)}" @uploaded="(val) => {uploaded(val, item)}" />
          <p class="error-msg" :class="validate[item.key] ? 'active': ''">{{ validateMsg[item.key] }}</p>
        </div>
        <div v-if="item.type === 'rate'" :key="item.key" class="field-item">
          <!-- <p :for="item.key">{{ item.id + '.' + item.label }}</p> -->
          <p class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</p>
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-rating id="item.key" v-model="formData[item.key]" color="#d04a02" :length="item.meta.max" empty-icon="$vuetify.icons.ratingFull" half-increments :disabled="item.meta.disabled" hover @input="(val) => {validField(item, val);checkNextShow(item, index)}" />
          <!-- checkNextShow(item, index) -->
          <p class="error-msg" :class="validate[item.key] ? 'active': ''">{{ validateMsg[item.key] }}</p>
        </div>
        <div v-if="item.type === 'slider'" :key="item.key" class="field-item">
          <label class="field-item-label" :class="item.required ? 'question-label_required':'question-label-norequired'" :for="item.key">{{ item.label }}</label>
          <div class="field-item-desc">{{ item.desc }}</div>
          <v-slider v-model="formData[item.key]" color="#d04a02" :max="item.meta.max" :step="item.meta.step" :min="item.meta.min" thumb-color="#d04a02" :thumb-size="24" thumb-label="always" />
        </div>
        <div v-if="item.type === 'image'" :key="item.key" class="field-item">
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <v-img :src="item.meta.defaultValue" :width="item.meta.width" :height="item.meta.height" :class="'align-'+item.meta.position" />
        </div>
        <div v-if="item.type === 'section'" :key="item.key" class="field-item">
          <div v-if="item.desc" class="field-item-desc">{{ item.desc }}</div>
          <!-- <p>{{ item.meta.defaultValue }}</p> -->
          <!-- eslint-disable-next-line vue/no-v-html -->
          <p v-html="toDetail(item)" />
        </div>
      </template>
    </v-form>
    <v-layout v-if="questionList.length>0 && !hiddenSubmitBtn" row class="pwc-form-action" justify-space-around>
      <v-flex xs5>
        <v-btn color="#d04a02" depressed outline block @click="handleNext">提交</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// 手机端 动态表单
import { validRequired, validEmail } from '@/util/validation'
import {
  VRadioGroup,
  VTextarea,
  VTextField,
  VSelect,
  VDatePicker,
  VRating
} from 'vuetify/lib'
import PwcUploader from '@/components/PwcUpload'
import PwcUploadImgs from '@/components/PwcUploadImgs'
import Actions from '@/constants/action'
import { mapActions, mapState } from 'vuex'
import nextOne from '../common'
// import { upload } from '@/mixin/file'
import Draggable from 'vuedraggable'
import { Icon } from 'vant'
import { debounce } from 'throttle-debounce'

const dataTypePattern = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^1\d{10}$/,
  url: /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/,
  otherPhone: /^\d{6,14}$/,
  number: /^[+-]?\d+(\.\d+)?$/
}
export default {
  name: 'PwcDyFormDesktop',
  components: {
    VRadioGroup,
    VTextarea,
    VTextField,
    VSelect,
    VDatePicker,
    VRating,
    PwcUploader,
    UploadImgs: PwcUploadImgs,
    Draggable,
    [Icon.name]: Icon
  },
  props:{
      surveyType:{
        type: String,
        default: ''
      },
      surveyId:{
        type: String,
        default: ''
      }
  },
  filters: {
    getComponentName(item) {
      switch (item.type) {
        case 'checkbox':
          return 'VRadioGroup'
        case 'checkboxInput':
          return 'VRadioGroup'
      }
    },
    getProperyRule(item) {
      if (item.required) {
        if (
          item.meta.dataType &&
          item.meta.dataType !== 'string' &&
          item.meta.dataType !== 'url'
        ) {
          if (item.meta.dataType === 'phone') {
            if (item.meta.countryCode === 86) {
              return [
                v =>
                  !!v ||
                  (item.type === 'textarea' || item.type === 'input'
                    ? '请输入此项'
                    : '请选择此项'),
                v =>
                  !!dataTypePattern[item.meta.dataType].test(v) ||
                  (item.type === 'textarea' ||
                  item.type === 'input' ||
                  item.type === 'number'
                    ? '请输入正确的' + item.label
                    : '请选择此项')
              ]
            } else {
              return [
                v =>
                  !!v ||
                  (item.type === 'textarea' || item.type === 'input'
                    ? '请输入此项'
                    : '请选择此项'),
                v =>
                  !!dataTypePattern['otherPhone'].test(v) ||
                  (item.type === 'textarea' ||
                  item.type === 'input' ||
                  item.type === 'number'
                    ? '请输入正确的' + item.label
                    : '请选择此项')
              ]
            }
          } else {
            return [
              v =>
                !!v ||
                (item.type === 'textarea' || item.type === 'input'
                  ? '请输入此项'
                  : '请选择此项'),
              v =>
                !!dataTypePattern[item.meta.dataType].test(v) ||
                (item.type === 'textarea' ||
                item.type === 'input' ||
                item.type === 'number'
                  ? '请输入正确的' + item.label
                  : '请选择此项')
            ]
          }
        } else {
          return [
            v =>
              !!v ||
              (item.type === 'textarea' ||
              item.type === 'input' ||
              item.type === 'number'
                ? '请输入此项'
                : '请选择此项')
          ]
        }
      }
    }
  },
  mixins: [nextOne],
  data: vm => ({
    valid: false,
    rules: {
      required: validRequired,
      email: validEmail
    },
    validate: {},
    validateMsg: {},
    showSchoolPane: false,
    filteredSchoolList: [],
    hasUploadFlag: true,
    fileList:[],
    isFileFlag: null
  }),
  computed: {
    tempFiles() {
      return this.$store.getters.tempFiles
    },
    ...mapState(['loading'])
  },
  watch: {
    hasUploadFlag:{
         handler(val){
           this.$nextTick(()=>{
            const types = [
            'rate',
            'fileupload',
            'imgupload',
            'uploadImgs',
            'checkbox',
            'checkboxInput',
            'radio',
            'select'
          ]
          if(!val){
              this.questionList.forEach(item =>{
                    if (item.required && types.includes(item.type)) {
  
                     this.$set(this.validate, item.key, false)
                }
              })
          }
           })
         }
    },
    questionList: {
      handler(val) {
        // 必填项初始化验证
        this.validate = {}
        this.validateMsg = {}
        this.$nextTick(() => {
          const types = [
            'rate',
            'fileupload',
            'imgupload',
            'uploadImgs',
            'checkbox',
            'checkboxInput',
            'radio',
            'select'
          ]
          val.forEach(item => {
            if (item.required && types.includes(item.type)) {
              this.$set(this.validate, item.key, false)
              if (item.type === 'fileupload') {
                this.$set(this.validateMsg, item.key, '请选择文件')
              } else if (item.type === 'imgupload') {
                this.$set(this.validateMsg, item.key, '请选择图片')
              } else {
                this.$set(this.validateMsg, item.key, '请选择此项')
              }
              if (item.type === 'radio' || item.type === 'select' || item.type === 'checkbox' || item.type === 'sorting') {
                item.options.forEach(op => {
                  if (op.id && op.id.endsWith('Other')) {
                    this.$set(this.validate, item.key + 'Other', false)
                    this.$set(
                      this.validateMsg,
                      item.key + 'Other',
                      '请输入'
                    )
                  }
                })
              }
            }
          })
        })
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.handleDebounceSchoolSearch = debounce(200, this.handleSearchSchool)
  },
  methods: {
    ...mapActions({
      getVerifyCode: Actions.GET_VERIFY_CODE,
      saveTempSurvey: Actions.SAVE_TEMP_SURVEY
    }),
    hasUpload(val){
      this.hasUploadFlag = val
    },
     // 检查是否已经提交过报名
    checkIsSubmit(item){
      if(this.surveyType === 'EREG'){
        this.checkLeadIsRegistered({surveyId: this.surveyId, eventId: this.$route.query.id, phoneNumber: this.formData[item.key]}) 
      }
    },
    getProperyRules(item) {
      if (item.required) {
        if (
          item.meta.dataType &&
          item.meta.dataType !== 'string' &&
          item.meta.dataType !== 'url'
        ) {
          if (item.meta.dataType === 'phone') {
            if (item.meta.countryCode === 86) {
              return [
                v =>
                  !!v ||
                  (item.type === 'textarea' || item.type === 'input'
                    ? '请输入此项'
                    : '请选择此项'),
                v =>
                  !!dataTypePattern[item.meta.dataType].test(v) ||
                  (item.type === 'textarea' ||
                  item.type === 'input' ||
                  item.type === 'number'
                    ? '请输入正确的' + item.label
                    : '请选择此项')
              ]
            } else {
              return [
                v =>
                  !!v ||
                  (item.type === 'textarea' || item.type === 'input'
                    ? '请输入此项'
                    : '请选择此项'),
                v =>
                  !!dataTypePattern['otherPhone'].test(v) ||
                  (item.type === 'textarea' ||
                  item.type === 'input' ||
                  item.type === 'number'
                    ? '请输入正确的' + item.label
                    : '请选择此项')
              ]
            }
          } else if (item.meta.dataType === 'custom') {
            return [
              v =>
                !!v ||
                  (item.type === 'textarea' || item.type === 'input'
                    ? '请输入此项'
                    : '请选择此项'),
              v =>
                !!(new RegExp(item.meta.pattern.replaceAll('/', ''))).test(v) ||
                  (item.type === 'textarea' ||
                  item.type === 'input' ||
                  item.type === 'number'
                    ? '请输入正确的' + item.label
                    : '请选择此项')
            ]
          } else {
            return [
              v =>
                !!v ||
                (item.type === 'textarea' || item.type === 'input'
                  ? '请输入此项'
                  : '请选择此项'),
              v =>
                !!dataTypePattern[item.meta.dataType].test(v) ||
                (item.type === 'textarea' ||
                item.type === 'input' ||
                item.type === 'number'
                  ? '请输入正确的' + item.label
                  : '请选择此项')
            ]
          }
        } else {
          return [
            v =>
              !!v ||
              (item.type === 'textarea' ||
              item.type === 'input' ||
              item.type === 'number'
                ? '请输入此项'
                : '请选择此项')
          ]
        }
      }
    },
    handleNext() {
      const valid = this.$refs.form.validate()
      this.validateForm()
      if (!Object.values(this.validate).includes(true) && valid) {
        if( this.fileList){
          this.formData.files = this.fileList
        }
        this.$emit('submitForm', this.formData)
      }
    },
    uploadOrDelete(val, item) {
      this.formData[item.key] = val
    },
    uploadFileList(val, flag){
      this.fileList = val
      this.isFileFlag = flag
    },
    formatNumber(item) {
      if (item.type === 'number') {
        let val = this.formData[item.key] || 0
        val = Number(val.toString().replace(/\b(0+)/gi, ''))
        if (item.meta.max && item.meta.min) {
          val = val > item.meta.max ? item.meta.max : val
          val = val < item.meta.min ? item.meta.min : val
        }
        this.$set(this.formData, item.key, val)
      }
    },
    handleSearchSchool() {
      const ret = []
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const key = this.formData[schoolInfo.key].toLowerCase()
      if (!key) {
        this.filteredSchoolList = []
        return
      }
      this.school_en =  this.reduceArr(this.school_en)
      this.school_zh =  this.reduceArr(this.school_zh)
      for (let i = 0; i < this.school_zh.length; i++) {
        const v = this.school_zh[i]
        if (v.includes(key)) {
          ret.push(v)
        }
      }
      if (ret.length === 0) {
        for (let i = 0; i < this.school_en.length; i++) {
          const v = this.school_en[i]
          if (v.toLowerCase().includes(key)) {
            ret.push(v)
          }
        }
      }
      this.filteredSchoolList = ret.slice(0, 50)
    },
    handleSchoolFocus() {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      this.showSchoolPane = true
    },
    handleSchoolBlur() {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const timer = setTimeout(() => {
        this.showSchoolPane = false
        clearTimeout(timer)
      }, 200)
    },
    handleSchoolSelect(v) {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      this.formData[schoolInfo.key] = v
      this.handleSearchSchool(v)
    },
    highlightKeyWord(word) {
      const schoolInfo = this.questionList.find(item => item.default === 'SCHOOL')
      if (!schoolInfo) {
        return
      }
      const key = this.formData[schoolInfo.key]
      const reg = new RegExp(`${key}`, 'i')
      const regResult = reg.exec(word)
      if (regResult && regResult.length > 0 && regResult[0]) {
        return word.replace(regResult[0], `<span style="color: #d04a02;">${regResult[0]}</span>`)
      }

      return word.replace(key, `<span style="color: #d04a02;">${key}</span>`)
    }
  }
}
</script>
<style lang="scss" scoped>
.pwc-school-pane.desktop {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
  line-height: 48px;
  margin-top: -22px;
  max-height: 300px;
  overflow-y: scroll;
  background: #fff;
  position: relative;
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
  .no-match {
    cursor: not-allowed;
    &:hover {
      background: #fff;
    }
  }
  div {
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    &:hover {
      background: rgb(243,243,243);
    }
  }
}
</style>
<style lang="scss">
.pwc-form-data {
  font-family: "Microsoft YaHei";
}
.v-date-picker-table .v-btn.v-btn--active {
  color: #000;
}
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #aaa;
}

.drag-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dotted #ccc;
  padding: 5px;
  margin: 5px;
}

.field-item {
  padding-bottom: 0.2rem;
  .field-item-label {
    font-size: 16px;
    line-height: 24px;
    margin: 10px 0;
  }
  .field-item-desc {
    font-size: 12px;
    line-height: 16px;
    margin: 10px 0;
  }
  .v-input__control {
    width: 100% !important;
  }
}
.sorting {
    .v-input__slot {
      margin: -10px -5px -10px 2px !important
    }
    .drag-item {
      line-height: 45px;
    }
  }
.question-label_required::before {
  position: relative;
  left: -5px;
  color: #d04a02;
  font-size: 16px;
  content: "*";
}

.question-label-norequired {
  position: relative;
  left: -10px;
}
.error-msg {
  font-size: 12px;
  color: #ee0a24;
  margin-left: 10px;
  visibility: hidden;
  -webkit-animation-name: fadeIn; /*动画名称*/
  -webkit-animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation-iteration-count: 1; /*动画次数*/
  -webkit-animation-delay: 0s; /*延迟时间*/
}
.active {
  visibility: visible;
}

.v-input--selection-controls__input {
  align-self: start;
}

.v-input__control {
  textarea {
    margin-top: 5px !important;
  }
}
.v-rating {
  .v-icon {
    font-size: 18px !important;
  }
}
.pwc-form-data .v-image {
  max-width: 100%;
}
.pwc-form-data .align-center {
  margin-left: auto;
  margin-right: auto;
}
.pwc-form-data .align-right {
  margin-left: auto;
}
</style>
